
export function uidEqual(a, b) {
    if( !a || !b) return 0

    return (a.length > 4 && b.length > 4) && (a.includes(b) || b.includes(a))
}


export function hasInterface(clazz) {
    return (clazz & 0b10000000) > 0
}
export function hasBM(clazz) {
    return (clazz & 0b01000000) > 0
}
export function hasControl(clazz) {
    return (clazz & 0b00100000) > 0
}
export function hasDccgen(clazz) {
    return (clazz & 0b00010000) > 0
}
export function hasProgrammer(clazz) {
    return (clazz & 0b00001000) > 0
}
export function hasAccessory(clazz) {
    return (clazz & 0b00000100) > 0
}
export function hasBooster(clazz) {
    return (clazz & 0b00000010) > 0
}
export function hasLight(clazz) {
    return (clazz & 0b00000001) > 0
}

export const BIDIB_CS_STATE_OFF = 0x00
export const BIDIB_CS_STATE_STOP           = 0x01  // DCC, all speed setting = 0
export const BIDIB_CS_STATE_SOFTSTOP       = 0x02  // DCC, soft stop is progress
export const BIDIB_CS_STATE_GO             = 0x03  // DCC on (must be repeated if watchdog is on)
export const BIDIB_CS_STATE_GO_IGN_WD      = 0x04  // DCC on (watchdog ignored)
export const BIDIB_CS_STATE_PROG           = 0x08  // in Programming Mode (ready for commands)
export const BIDIB_CS_STATE_PROGBUSY       = 0x09  // in Programming Mode (busy)
export const BIDIB_CS_STATE_BUSY           = 0x0D  // busy
export const BIDIB_CS_STATE_QUERY          = 0xFF
